import { groupBy } from "lodash-es";
import moment from "moment-timezone";
import ClassModel from "src/models/ClassModel";
import { dateFormat } from "src/utils/constants";

interface Props {
  class: ClassModel;
}

export function AvailableSoon(props: Props) {
  const today = moment();

  const pendingCancellation = props.class.registrations.filter((r) => {
    const endDate = props.class.endDate && moment(props.class.endDate);

    if (r.finalDate) {
      const registrationFinalDate = moment(r.finalDate);

      let isFutureFinalDate = registrationFinalDate.isAfter(today);

      if (endDate) {
        isFutureFinalDate =
          isFutureFinalDate && registrationFinalDate.isBefore(endDate);
      }

      if (isFutureFinalDate) {
        return true;
      }
    }

    return false;
  });

  if (pendingCancellation.length === 0) {
    return null;
  }

  const grouped = groupBy(pendingCancellation, (r) =>
    moment(r.finalDate).format("YYYY-MM-DD")
  );

  return (
    <div className="mt-2 max-w-sm rounded border border-borderGray bg-white text-sm">
      <div className="divide-y divide-borderGray">
        {Object.keys(grouped).map((k) => {
          const registrationCount = grouped[k].length;

          return (
            <div key={k} className="px-4 py-2">
              <strong>
                {registrationCount.toLocaleString()} spot
                {registrationCount !== 1 && "s"} available
              </strong>{" "}
              {moment(k).add(1, "day").format(dateFormat)}
            </div>
          );
        })}
      </div>
    </div>
  );
}
